"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Secp256k1PubKeyType = void 0;
exports.Secp256k1PubKeyType = '/tm.PubKeySecp256k1';
